// src/app/_directives/direction.directive.ts
import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LanguageDirectionService } from '../_services/language-direction.service';

@Directive({
    selector: '[appDynamicDirection]',
})
export class DirectionDirective implements OnInit, OnDestroy {
    private subscription: Subscription;

    constructor(
        private el: ElementRef,
        private directionService: LanguageDirectionService
    ) { }

    ngOnInit() {
      this.subscription = this.directionService.direction$.subscribe((direction) => {
        this.el.nativeElement.setAttribute('dir', direction);
      });
    }

    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_directives/direction.directive.ts